@if (pending) {
  <div
    class="ph-survey-popover"
    [class.--left]="pending.survey.appearance?.position === 'left'"
    [class.--center]="pending.survey.appearance?.position === 'center'"
    role="dialog"
    aria-modal="false"
  >
    <button
      type="button"
      class="ph-survey-popover__close"
      (click)="onClose()"
      aria-label="Schliessen"
    >
      <mat-icon>close</mat-icon>
    </button>

    @if (!showThankYou && currentQuestion) {
      <header class="ph-survey-popover__header">
        <h3 class="ph-survey-popover__question">
          {{ currentQuestion.question }}
        </h3>
        @if (currentQuestion.description) {
          <p class="ph-survey-popover__description">
            {{ currentQuestion.description }}
          </p>
        }
        @if (showStepIndicator) {
          <span class="ph-survey-popover__step">
            {{ currentStep }} / {{ pathTotal }}
          </span>
        }
      </header>

      <div class="ph-survey-popover__body">
        @switch (currentQuestion.type) {
          @case ('rating') {
            <div
              class="ph-rating"
              [class.--stars]="currentQuestion.display === 'emoji'"
              [class.--number]="currentQuestion.display === 'number'"
              (mouseleave)="onRatingLeave()"
            >
              @for (value of ratingValues(currentQuestion); track value) {
                <button
                  type="button"
                  class="ph-rating__btn"
                  [class.--active]="isRatingActive(currentQuestion, value)"
                  (click)="onRatingSelect(currentQuestion, value)"
                  (mouseenter)="onRatingHover(value)"
                  [attr.aria-label]="value"
                >
                  @if (currentQuestion.display === 'emoji') {
                    <mat-icon
                      class="ph-rating__star"
                      [class.fill-1]="isStarFilled(currentQuestion, value)"
                      [class.fill-0]="!isStarFilled(currentQuestion, value)"
                      >star</mat-icon
                    >
                  } @else {
                    {{ value }}
                  }
                </button>
              }
            </div>
            @if (
              currentQuestion.lowerBoundLabel || currentQuestion.upperBoundLabel
            ) {
              <div class="ph-rating__labels">
                <span>{{ currentQuestion.lowerBoundLabel }}</span>
                <span>{{ currentQuestion.upperBoundLabel }}</span>
              </div>
            }
          }
          @case ('open') {
            <textarea
              class="ph-survey-popover__textarea"
              rows="4"
              [placeholder]="pending.survey.appearance?.placeholder || ''"
              [value]="$any(responses[currentQuestion.id]) || ''"
              (input)="onOpenInput(currentQuestion, $any($event.target).value)"
            ></textarea>
          }
          @case ('single_choice') {
            <div class="ph-choices">
              @for (choice of currentQuestion.choices; track choice) {
                <button
                  type="button"
                  class="ph-choices__btn"
                  [class.--active]="isChoiceActive(currentQuestion, choice)"
                  (click)="onSingleChoiceSelect(currentQuestion, choice)"
                >
                  {{ choice }}
                </button>
              }
            </div>
          }
          @case ('multiple_choice') {
            <div class="ph-choices --multi">
              @for (choice of currentQuestion.choices; track choice) {
                <button
                  type="button"
                  class="ph-choices__btn"
                  [class.--active]="
                    isMultiChoiceActive(currentQuestion, choice)
                  "
                  (click)="onMultiChoiceToggle(currentQuestion, choice)"
                >
                  {{ choice }}
                </button>
              }
            </div>
          }
          @case ('link') {
            <a
              class="ph-survey-popover__link"
              [href]="currentQuestion.link"
              target="_blank"
              rel="noopener noreferrer"
              (click)="onLinkClick(currentQuestion)"
            >
              {{ currentQuestion.buttonText || currentQuestion.link }}
            </a>
          }
        }
      </div>

      <footer class="ph-survey-popover__footer">
        @if (currentQuestion.optional) {
          <button
            type="button"
            class="ph-survey-popover__skip"
            (click)="onSkip()"
          >
            Überspringen
          </button>
        }
        @if (showSubmitButton) {
          <button
            type="button"
            class="ph-survey-popover__submit"
            [disabled]="isSubmitDisabled"
            (click)="onNext()"
          >
            {{ currentQuestion.buttonText || 'Weiter' }}
          </button>
        }
      </footer>
    }

    @if (showThankYou) {
      <div class="ph-survey-popover__thankyou">
        <h3 class="ph-survey-popover__thankyou-header">
          {{ pending.survey.appearance?.thankYouMessageHeader }}
        </h3>
        @if (pending.survey.appearance?.thankYouMessageDescription) {
          <p class="ph-survey-popover__thankyou-description">
            {{ pending.survey.appearance?.thankYouMessageDescription }}
          </p>
        }
        <button
          type="button"
          class="ph-survey-popover__submit"
          (click)="onThankYouClose()"
        >
          {{
            pending.survey.appearance?.thankYouMessageCloseButtonText ||
              'Schliessen'
          }}
        </button>
      </div>
    }
  </div>
}
